__turbopack_context__.v({
  "className": "cormorant_garamond_339fe0f-module__F92Xpa__className",
});
